import PropTypes from 'prop-types';

import { theme } from '@prose-ui';
import { legacyTheme } from '@prose-ui/legacy';
import { withStyles } from 'legacyStyles';

import ListItems from '../Components/ListItems';
import { Typography } from '../Components/Typography';

import BlockLayout from 'Blocks/BlockLayout';

const styles = {
  root: {
    width: '100%',
    background: theme.colors.tertiary[100],
  },
  texts: {
    marginBottom: legacyTheme.spacing.s36,
    paddingRight: 100,
    [legacyTheme.breakpoints.match('md')]: {
      paddingRight: 0,
      marginBottom: legacyTheme.spacing.s32,
    },
    [legacyTheme.breakpoints.up('md')]: {
      display: 'flex',
      paddingBottom: legacyTheme.spacing.s32,
      borderBottom: `1px solid ${theme.colors.neutral[700]}`,
    },
  },
  title: {
    marginRight: `${legacyTheme.spacing.s36}`,
  },
  intro: {
    maxWidth: 650,
  },
  categoryTitle: {
    marginBottom: legacyTheme.spacing.s8,
    fontWeight: 500,
    [legacyTheme.breakpoints.match('md')]: {
      marginBottom: legacyTheme.spacing.s16,
    },
  },
  listWrapper: {
    flex: '1',
  },
};

const List = ({ classes, title, intro, categoryTitle, data, data_manmade, listName }) => (
  <BlockLayout className={classes?.root} contentWidth="wide">
    <div className={classes.texts}>
      <Typography className={classes?.title} paragraph variant="h2" whiteSpace="nowrap">
        {title}
      </Typography>
      <Typography className={classes?.intro} variant="p1">
        {intro}
      </Typography>
    </div>
    <Typography className={classes?.categoryTitle} variant="p1">
      {categoryTitle}
    </Typography>
    <div className={classes?.listWrapper}>
      <ListItems data={data} listName={listName} />
      {data_manmade && <ListItems data={data_manmade} listName="man-made" showAsterisk />}
    </div>
  </BlockLayout>
);

List.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  title: PropTypes.string.isRequired,
  intro: PropTypes.string.isRequired,
  categoryTitle: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  data_manmade: PropTypes.array,
  listName: PropTypes.string,
};

export default withStyles(List, styles);
